import Dragger from "antd/lib/upload/Dragger";
import React from "react";
import { InboxOutlined } from "@ant-design/icons";
import { Button, Image, Popconfirm, Typography, message } from "antd";
import { useEffect, useState } from "react";
import { ExclamationCircleOutlined, LoadingOutlined, CloseCircleOutlined } from "@ant-design/icons";
import { Input, Modal } from "antd";
import { useSelector } from "react-redux";
import { changeExtensiontoLowerCase, getPreSignedUrls } from "../utils/extraFunctions";

const { confirm } = Modal;

const DraggerCompEmailPreview = ({ uploadFile, toggle, source, imageUrl, openFor, setIsmodal, accept,fileData,setFileData,loading,setLoading,previewUrl,setPreviewUrl }) => {

  const [fileText, setFileText] = useState({ name: null, size: null });
 





  const deleteImg=()=>{
    setPreviewUrl(null);
    setFileText({});
    uploadFile.current = "";
    if (setIsmodal) {
        setIsmodal((prev) => ({ ...prev, isDeleteImage: true }));
        setTimeout(() => {
            setIsmodal((prev) => ({ ...prev, isDeleteImage: false, isImagePasted:false }));
        }, 1000);
      }

  }


  // Handling PropertyDocs

  function beforeUpload(file) {
    const isImage = file.type.startsWith("image/");
    const isSupportedFormat = ["image/jpeg", "image/png", "image/jpg", "image/webp"].includes(file.type);
  
    if (!isImage || !isSupportedFormat) {
      message.error("Only JPG, PNG, or WEBP images are allowed.");
      return false;
    }
  
    const isLt20M = file.size / 1024 / 1024 < 20;
    if (!isLt20M) {
      message.error("Image must be smaller than 20MB!");
      return false;
    }
  
    return true;
  }
  let handleCustome = (event) => {
    const rawFile = event?.file?.originFileObj || event?.file;
    if (!rawFile) return;
  
    const fileName = changeExtensiontoLowerCase(rawFile.name);
    const fileSize = bytesToSize(rawFile.size);
  
    setFileText({ name: fileName, size: fileSize });

  
    // Fix: use rawFile for preview
    const previewUrl = URL.createObjectURL(rawFile);
    setPreviewUrl(previewUrl);
    setFileData(rawFile);
  };

  function bytesToSize(bytes) {
    let sizes = ["Bytes", "KB", "MB", "GB", "TB"];
    if (bytes === 0) return "0 Byte";
    let i = parseInt(Math.floor(Math.log(bytes) / Math.log(1024)));
    return Math.round(bytes / Math.pow(1024, i), 2) + " " + sizes[i];
  }



  useEffect(() => {
    if(openFor==='EDIT' && imageUrl){
        setPreviewUrl(imageUrl);
    }

    return () => {
      setPreviewUrl(null);
    }
  }, [imageUrl, openFor])


// //   for paste event
// useEffect(() => {
//     const PasteEventFunction = (event) => {
//       setLoading(true);
//       const items = (event.clipboardData || event.originalEvent.clipboardData).items;
//       const fileItem = Array.from(items).find(item => item.kind === "file");
//       if (fileItem) {
//         const blob = fileItem.getAsFile();
//         try {
//           const checkImage = beforeUpload(blob);
//           if (!checkImage) {
//             message.error("File type not supported");
//             return;
//           }
//         } catch (err) {
//           message.error(err.message);
//           return;
//         }
//         const reader = new FileReader();
//         const ide = Math.floor(10000 + Math.random() * 90000);
//         const imageName = "pastedImage" + ide;
//         const updatedBlob = new File([blob], imageName, { type: blob.type });
//         reader.onload = () => {
//           const base64String = reader.result.replace(/^data:.+;base64,/, "");
//           setPreviewUrl(base64String);
//           setLoading(false);
//         };
//         reader.readAsDataURL(blob);
//         setShowInputFileName(true);
//         const fileName = changeExtensiontoLowerCase(blob?.name)

//         const fileSize = bytesToSize(blob?.size);
//         setFileSizeOfDocUpload(fileSize);
//         const formData = new FormData();
//             formData.append("file", updatedBlob);
//         if (!toggle) {
//           formData.append("fileType", blob?.type?.includes("image") ? "IMAGE" : "PDF");
//         }
//         uploadFile.current = formData;
//         if(setIsmodal){
//             setIsmodal(prev=>({...prev, isImagePasted:true}));
//         }
//       } else {
//         setLoading(false);
//       }
//     };

//     const getModal = document.querySelector("#uploaddiv");
//     getModal?.addEventListener("paste", PasteEventFunction);

//     return () => {
//       getModal?.removeEventListener("paste", PasteEventFunction);
//     };
//   }, [beforeUpload, toggle]);




  return (
    <>
      <div id="uploaddiv">
        <div  style={{ display: (loading || previewUrl) ? "none" : "flex" }}>
        <Dragger
          progress={false}
          style={{ width: "400px" }}
          accept={accept}
          showUploadList={false}
          customRequest={handleCustome}
          beforeUpload={beforeUpload}
        >
          <p className="ant-upload-drag-icon">
            <InboxOutlined />
          </p>
         <>
         <p className="ant-upload-text">Paste, Click or drag file to this area to upload</p>
         {source ==="EMAIL_SIGN" ?
          <p className="ant-upload-hint">The recommended aspect ratio for the image is 600x300 pixels.</p>:
          <p className="ant-upload-hint">Support for a single Image upload. Strictly prohibit from uploading company data or other band files</p>}
          </>
        </Dragger>
        </div>

        {toggle?
        <div style={{display:"flex",justifyContent:"center",flexDirection:"column",marginTop:"20px"}}>
         <div>
              <div
                style={{
                  width: "10%",
                  margin: "auto",
                  display: loading ? "flex" : "none",
                }}
              >
                <LoadingOutlined
                  style={{
                    fontSize: 64,
                  }}
                  spin
                />
              </div>


              <div
                style={{
                  display: (previewUrl) ? "flex" : "none",
                  width: "40%",
                  margin: "auto",
                }}
              >
                {(previewUrl) && (
                  <Image
                   src={ previewUrl}
                   
                   loading="lazy"
                   preview={{
                    visible: false,
                    mask: (
                      <div
                        style={{
                          cursor: "pointer",
                          position: "absolute",
                          zIndex: 21,
                          top: "0px",
                          right: "0px",
                        }}
                      >
                        <div
                          onClick={(event) => {
                            event.stopPropagation();
                          }}
                        >
                          <Popconfirm
                            title="Are you sure you want to delete this image?"
                            onConfirm={() => {
                              deleteImg();
                            }}
                            okText="Yes"
                            cancelText="No"
                          >
                            <CloseCircleOutlined
                              style={{ fontSize: "30px" }}
                            />
                          </Popconfirm>
                        </div>
                      </div>
                    ),
                  }}
                   />
                )}
              </div>
            </div>

            {fileText?.name && (
              <div>
                <div style={{ textAlign: "center" }}>
                  <Typography.Text type="secondary">
                    <strong>File Name:</strong> {fileText.name}
                  </Typography.Text>
                  <br />
                  <Typography.Text type="secondary">
                    <strong>Size:</strong> {fileText.size}
                  </Typography.Text>
                </div>
              </div>
            )}
        
            </div> : null}
      </div>
    </>
  );
};

export { DraggerCompEmailPreview };
